import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import { useSiteInfo } from '../lib/settingsContext';
import { useServices } from '../lib/cms';

export default function Footer() {
  const site = useSiteInfo();
  const services = useServices();
  return (
    <footer className="relative bg-aqc-red text-white">
      <div className="container-aqc relative py-16 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" aria-label="Apex Quality Control home" className="inline-flex items-center">
            <img
              src="/assets/brand/logo-footer-white.png"
              alt="Apex Quality Control"
              className="block object-contain w-auto h-14 md:h-16 lg:h-[68px]"
              style={{ maxWidth: '100%' }}
            />
          </Link>
          <p className="mt-5 text-sm/relaxed text-white/85 max-w-sm">
            Independent inspection, testing and audit services — from the factory floor to final shipment.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 text-[0.72rem] font-semibold tracking-[0.18em] uppercase bg-white/10 border border-white/20 rounded-full px-4 py-1.5">
            Independent · Impartial · Global
          </div>
          <div className="mt-6 flex items-center gap-3">
            {[Linkedin, Twitter, Facebook].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="Social"
                className="h-9 w-9 rounded-full border border-white/25 flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-serif text-[0.72rem] tracking-[0.18em] uppercase text-white/70">Company</h4>
          <ul className="mt-4 space-y-2.5 text-[0.94rem]">
            <li><Link to="/about" className="hover:text-white/80">About</Link></li>
            <li><Link to="/why-us" className="hover:text-white/80">Why AQC</Link></li>
            <li><Link to="/standards" className="hover:text-white/80">Standards</Link></li>
            <li><Link to="/resources" className="hover:text-white/80">Resources</Link></li>
            <li><Link to="/gallery" className="hover:text-white/80">Gallery</Link></li>
            <li><Link to="/news" className="hover:text-white/80">News</Link></li>
            <li><Link to="/contact" className="hover:text-white/80">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-serif text-[0.72rem] tracking-[0.18em] uppercase text-white/70">Services</h4>
          <ul className="mt-4 space-y-2.5 text-[0.94rem]">
            {services.map((s) => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-white/80">{s.title}</Link></li>
            ))}
            <li><Link to="/services" className="font-semibold text-white/95">All Services →</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-serif text-[0.72rem] tracking-[0.18em] uppercase text-white/70">Get in Touch</h4>
          <ul className="mt-4 space-y-3 text-[0.94rem]">
            <li className="flex items-start gap-2.5">
              <Mail size={16} className="mt-0.5 shrink-0" />
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <Phone size={16} className="mt-0.5 shrink-0" />
              <a href={`tel:${site.phoneRaw}`}>{site.phone}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>
                {site.address.line1}<br />
                {site.address.line2}<br />
                {site.address.city}, {site.address.country}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/15">
        <div className="container-aqc py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/70">
          <div>&copy; {new Date().getFullYear()} Apex Quality Control. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-white">Cookie Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Use</Link>
            <Link to="/admin/login" className="hover:text-white opacity-70">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
